// extracted by mini-css-extract-plugin
export default {"header":"styles_header__Uru4u","close":"styles_close__e7c73","title":"styles_title__EkPRm"};